import { Link } from 'react-router-dom'

function Sitemap() {
  return (
    <div className="py-5">
      <div className="container">
        <h1 className="display-4 fw-bold text-center mb-5">Site Map</h1>
        <p className="fs-5 text-muted text-center mb-5 mx-auto" style={{maxWidth: '48rem'}}>
          Find everything on The Salty Mermaid website. Navigate easily to all our pages and features.
        </p>

        <div className="row g-4">
          {/* Main Pages */}
          <div className="col-md-6 col-lg-4">
            <div className="bg-white rounded shadow p-4">
              <h2 className="fs-4 fw-bold mb-4 text-primary d-flex align-items-center">
                <span className="me-2">🏠</span>
                Main Pages
              </h2>
              <ul className="gap-3 d-flex flex-column list-unstyled">
                <li>
                  <Link to="/" className="text-primary text-decoration-none d-flex align-items-center">
                    <span className="me-2">🏡</span>
                    Home - Welcome & Overview
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-primary text-decoration-none d-flex align-items-center">
                    <span className="me-2">ℹ️</span>
                    About Us - Our Story & Team
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-primary text-decoration-none d-flex align-items-center">
                    <span className="me-2">📞</span>
                    Contact - Get in Touch
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Classes & Learning */}
          <div className="col-md-6 col-lg-4">
            <div className="bg-white rounded shadow p-4">
              <h2 className="fs-4 fw-bold mb-4 text-primary d-flex align-items-center">
                <span className="me-2">🎨</span>
                Classes & Learning
              </h2>
              <ul className="gap-3 d-flex flex-column list-unstyled">
                <li>
                  <Link to="/classes" className="text-primary text-decoration-none d-flex align-items-center">
                    <span className="me-2">📚</span>
                    Art Classes - Browse & Book
                  </Link>
                </li>
                <li className="ps-4 text-muted small">
                  • Watercolor Fundamentals
                </li>
                <li className="ps-4 text-muted small">
                  • Acrylic Painting Techniques
                </li>
                <li className="ps-4 text-muted small">
                  • Mixed Media Workshops
                </li>
                <li className="ps-4 text-muted small">
                  • Oil Painting Portraits
                </li>
                <li className="ps-4 text-muted small">
                  • Digital Art Basics
                </li>
              </ul>
            </div>
          </div>

          {/* Account & User Features */}
          <div className="col-md-6 col-lg-4">
            <div className="bg-white rounded shadow p-4">
              <h2 className="fs-4 fw-bold mb-4 text-primary d-flex align-items-center">
                <span className="me-2">👤</span>
                Account Features
              </h2>
              <ul className="gap-3 d-flex flex-column list-unstyled">
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">🔐</span>
                  Sign In / Register
                </li>
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">💳</span>
                  Secure Checkout (Square)
                </li>
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">📧</span>
                  Order Confirmations
                </li>
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">👥</span>
                  Customer Accounts
                </li>
              </ul>
            </div>
          </div>

          {/* Social & External */}
          <div className="col-md-6 col-lg-4">
            <div className="bg-white rounded shadow p-4">
              <h2 className="fs-4 fw-bold mb-4 text-primary d-flex align-items-center">
                <span className="me-2">🌐</span>
                Connect & Follow
              </h2>
              <ul className="gap-3 d-flex flex-column list-unstyled">
                <li>
                  <a 
                    href="https://www.facebook.com/thesaltymermaidart/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary text-decoration-none d-flex align-items-center"
                  >
                    <span className="me-2">📘</span>
                    Facebook Page
                    <span className="ms-1">↗</span>
                  </a>
                </li>
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">🛒</span>
                  Shopify Store Integration
                </li>
                <li className="text-dark d-flex align-items-center">
                  <span className="me-2">📊</span>
                  SharePoint Inventory Sync
                </li>
              </ul>
            </div>
          </div>

          {/* Admin Features */}
          <div className="col-md-6 col-lg-4">
            <div className="bg-white rounded shadow p-4">
              <h2 className="fs-4 fw-bold mb-4 text-primary d-flex align-items-center">
                <span className="me-2">⚙️</span>
                Admin Features
              </h2>
              <ul className="gap-3 d-flex flex-column list-unstyled">
                <li>
                  <Link to="/admin" className="text-primary text-decoration-none d-flex align-items-center">
                    <span className="me-2">🔧</span>
                    Admin Dashboard
                  </Link>
                  <span className="text-muted small d-block mt-1">(Admin users only)</span>
                </li>
                <li className="ps-4 text-muted small">
                  • Class Management
                </li>
                <li className="ps-4 text-muted small">
                  • Product Management
                </li>
                <li className="ps-4 text-muted small">
                  • Gallery Management
                </li>
                <li className="ps-4 text-muted small">
                  • Content Management
                </li>
                <li className="ps-4 text-muted small">
                  • Integration Settings
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="mt-5 bg-light rounded p-5">
          <h2 className="h2 fw-bold text-center mb-4">Quick Navigation</h2>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/" className="bg-white text-primary px-3 py-2 rounded text-decoration-none">
              🏡 Home
            </Link>
            <Link to="/classes" className="bg-white text-primary px-3 py-2 rounded text-decoration-none">
              🎨 Classes
            </Link>
            <Link to="/about" className="bg-white text-primary px-3 py-2 rounded text-decoration-none">
              ℹ️ About
            </Link>
            <Link to="/contact" className="bg-white text-primary px-3 py-2 rounded text-decoration-none">
              📞 Contact
            </Link>
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-4 text-center">
          <p className="text-muted">
            Can't find what you're looking for? 
            <Link to="/contact" className="text-primary text-decoration-none ms-2">
              Contact us for help
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Sitemap